import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { MAGAZINE_TAG_FOR_DESIGN_MAGAZINE_EDIT } from "../schema";

export const useMagazineTagQuery = () => {
	const { data } = useCustomSuspenseQuery(MAGAZINE_TAG_FOR_DESIGN_MAGAZINE_EDIT);

	return {
		magazineTagQueryData: data,
	};
};
